import { Routes } from '@angular/router';
import { CanAccessRoute } from './auth/route-access';
import { USER_ROLE } from './auth/user.model';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.routes').then((m) => m.routes),
  },
  {
    path: '',
    loadChildren: () => import('./features/pages/pages.routes').then((m) => m.routes),
  },
  {
    path: 'admin',
    canMatch: [CanAccessRoute([USER_ROLE.ADMIN, USER_ROLE.ADMIN_SELLER, USER_ROLE.SELLER])],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.routes),
  },
];
